<template>
  <BaseIdCard :numberPerRow="4" innerClass="items-center" @click="goToDetail()">
    <img :src="props.imprimante.urlImage" :alt="'image pour l\'imprimante ' + imprimante.marque + ' ' + imprimante.modele" class="w-3/4">

    <div class="w-full flex justify-between ">
      <div class="flex flex-col" v-show="!isEditing">
        <TitreUn :content="imprimante.modele" />
        <TitreDeux :content="imprimante.marque" fontSemiBold />
        <SimpleText :content="imprimante.consommation + ' ' + t('watts')" />
        <SimpleText :content="imprimante.prix + ' €'" />
        <SimpleText v-show="imprimante.ip" :content="imprimante.ip" />
      </div>

      <div class="flex flex-col gap-2 mr-2 w-full" v-show="isEditing">
        <div class="flex flex-row gap-2">
          <InputField @click.stop :placeholder="t('model')" v-model="newModel" showLabel/>
          <InputField @click.stop :placeholder="t('brand')" v-model="newMarque" showLabel/>
        </div>

        <div class="flex flex-row gap-2">
          <InputField @click.stop :placeholder="t('consommation')" v-model="newConsommation" type="number" showLabel/>
          <InputField @click.stop :placeholder="t('price')" v-model="newPrice" type="number" showLabel/>
        </div>

        <div class="flex flex-row gap-2">
          <InputField @click.stop :placeholder="t('ip')" v-model="newIp" showLabel class="!w-1/2"/>
          <DropDownField @click.stop :placeholder="t('purchaseType')" :values="typeAchatAvailable" v-model="newTypeAchat" showLabel class="!w-1/2"/>
        </div>

        <InputField @click.stop :placeholder="t('urlImgPrinter')" v-model="newUrlImage" showLabel/>
      </div>

      <div class="flex flex-col items-center justify-end gap-2">
        <OrangeEditIcon v-if="!isEditing" @click.stop="setToEditMode()" />
        <GreenCheckIcon v-if="isEditing" @click.stop="modifierImprimante()" />
        <RedTrashIcon @click.stop="props.showModalDelete(imprimante)" />
      </div>
    </div>
  </BaseIdCard>

</template>

<script setup>
import {computed, defineProps, ref} from 'vue';
import {t} from "@/utils/Traduction";
import {ImprimantesStore} from "@/stores/ImprimanteStore";
import {router} from "@/routeur";
import TitreUn from "@/components/atoms/TitreUn.vue";
import TitreDeux from "@/components/atoms/TitreDeux.vue";
import SimpleText from "@/components/atoms/SimpleText.vue";
import InputField from "@/components/molecules/InputField.vue";
import OrangeEditIcon from "@/components/atoms/OrangeEditIcon.vue";
import GreenCheckIcon from "@/components/atoms/GreenCheckIcon.vue";
import RedTrashIcon from "@/components/atoms/RedTrashIcon.vue";
import BaseIdCard from "@/components/molecules/BaseIdCard.vue";
import DropDownField from "@/components/molecules/DropDownField.vue";
import {TypeAchatStore} from "@/stores/TypeAchatStore";

const props = defineProps({
  imprimante: Object,
  showModalDelete: Function
});

const imprimanteStore = ImprimantesStore();
const typeAchatStore = TypeAchatStore();

typeAchatStore.loadTypeAchat();

const isEditing = ref(false);
const newMarque = ref(props.imprimante.marque);
const newModel = ref(props.imprimante.modele);
const newConsommation = ref(props.imprimante.consommation);
const newPrice = ref(props.imprimante.prix);
const newUrlImage = ref(props.imprimante.urlImage);
const newTypeAchat = ref(props.imprimante.uuidTypeAchat);
const newIp = ref(props.imprimante.ip);

const typeAchatAvailable = computed(() => {
  return typeAchatStore.typeAchat.map((type) => {
    return {
      id: type.uuid,
      display: type.libelle
    }
  });
})

function setToEditMode() {
  isEditing.value = true;
}

const modifierImprimante = () => {
  imprimanteStore.modifierImprimante(
      props.imprimante.uuid,
      newMarque.value,
      newModel.value,
      newConsommation.value,
      newPrice.value,
      newUrlImage.value,
      newTypeAchat.value,
      newIp.value === "" ? null : newIp.value,
      () => {
    isEditing.value = false;
  });
}

const goToDetail = async () => {
  await router.push({'path': '/admin/imprimantes/stats/' + props.imprimante.uuid});
}

</script>

<style scoped>
</style>
